import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-591622db"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "edit-task-modal__fields" }

import { ref, computed } from 'vue';
import type { Ref } from 'vue';

import TaskInterface from '@/interfaces/Task.interface';

import DSModal from '@/design-system/DSModal.vue';
import DSTextField from '@/design-system/DSTextField.vue';
import DSSelect from '@/design-system/DSSelect.vue';

import { useStore } from '@/store';
import { UPDATE_TASK } from '@/store/types/actions';

interface ProjectOption {
  label: string;
  value: number | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EditTaskModal',
  setup(__props, { expose: __expose }) {

const store = useStore();
const show_modal = ref(false);
const project_id = ref<number | null>(null);

const task: Ref<TaskInterface> = ref({} as TaskInterface);
const request_pending = ref(false);

const projects = computed(() => store.state.project.projects);

const parsedProjects = computed<ProjectOption[]>(() => [
  { label: 'No project', value: null },
  ...projects.value.map((project) => ({
    label: project.name,
    value: project.id,
  })),
]);

const openModal = (update_task: TaskInterface) => {
  task.value = { ...update_task };
  project_id.value = update_task.project?.id || null;
  return show_modal.value = true;
};

const closeModal = () => {
  show_modal.value = false;
};

const updateTask = async () => {
  request_pending.value = true;
  const project = projects.value.find(proj => proj.id === project_id.value);

  await store.dispatch(UPDATE_TASK, {
    ...task.value,
    project,
  });

  request_pending.value = false;
  return closeModal();
};

__expose({
  openModal,
  closeModal,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DSModal, {
    modelValue: show_modal.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((show_modal).value = $event)),
    title: "Edit Task",
    loading: request_pending.value,
    "confirm-label": "Save",
    onConfirm: updateTask,
    onCancel: closeModal
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(DSTextField, {
          modelValue: task.value.description,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((task.value.description) = $event)),
          label: "Description",
          placeholder: "Enter task description",
          icon: "task_alt",
          autofocus: "",
          "aria-label": "Task description"
        }, null, 8, ["modelValue"]),
        _createVNode(DSSelect, {
          modelValue: project_id.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((project_id).value = $event)),
          options: parsedProjects.value,
          label: "Project",
          icon: "folder",
          clearable: "",
          "aria-label": "Select project"
        }, null, 8, ["modelValue", "options"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "loading"]))
}
}

})